webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(38);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(117);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(57);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(56);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vueEvents = __webpack_require__(116);
	
	var _vueEvents2 = _interopRequireDefault(_vueEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueEvents2.default);
	
	var app = new _vue2.default((0, _extends3.default)({
	  router: _router2.default,
	  store: _store2.default
	}, _App2.default));
	
	app.$mount('#app');

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(114)
	
	/* script */
	__vue_exports__ = __webpack_require__(60)
	
	/* template */
	var __vue_template__ = __webpack_require__(127)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _setImmediate2 = __webpack_require__(67);
	
	var _setImmediate3 = _interopRequireDefault(_setImmediate2);
	
	var _promise = __webpack_require__(66);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _typeof2 = __webpack_require__(39);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object' && typeof exports.nodeName !== 'string') {
	        factory(exports);
	    } else {
	        factory(root.commonJsStrict = {});
	    }
	})(undefined, function (exports) {
	    if (typeof _promise2.default !== 'function') {
	        !function (a) {
	            function b(a, b) {
	                return function () {
	                    a.apply(b, arguments);
	                };
	            }function c(a) {
	                if ("object" != (0, _typeof3.default)(this)) throw new TypeError("Promises must be constructed via new");if ("function" != typeof a) throw new TypeError("not a function");this._state = null, this._value = null, this._deferreds = [], i(a, b(e, this), b(f, this));
	            }function d(a) {
	                var b = this;return null === this._state ? void this._deferreds.push(a) : void k(function () {
	                    var c = b._state ? a.onFulfilled : a.onRejected;if (null === c) return void (b._state ? a.resolve : a.reject)(b._value);var d;try {
	                        d = c(b._value);
	                    } catch (e) {
	                        return void a.reject(e);
	                    }a.resolve(d);
	                });
	            }function e(a) {
	                try {
	                    if (a === this) throw new TypeError("A promise cannot be resolved with itself.");if (a && ("object" == (typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a)) || "function" == typeof a)) {
	                        var c = a.then;if ("function" == typeof c) return void i(b(c, a), b(e, this), b(f, this));
	                    }this._state = !0, this._value = a, g.call(this);
	                } catch (d) {
	                    f.call(this, d);
	                }
	            }function f(a) {
	                this._state = !1, this._value = a, g.call(this);
	            }function g() {
	                for (var a = 0, b = this._deferreds.length; b > a; a++) {
	                    d.call(this, this._deferreds[a]);
	                }this._deferreds = null;
	            }function h(a, b, c, d) {
	                this.onFulfilled = "function" == typeof a ? a : null, this.onRejected = "function" == typeof b ? b : null, this.resolve = c, this.reject = d;
	            }function i(a, b, c) {
	                var d = !1;try {
	                    a(function (a) {
	                        d || (d = !0, b(a));
	                    }, function (a) {
	                        d || (d = !0, c(a));
	                    });
	                } catch (e) {
	                    if (d) return;d = !0, c(e);
	                }
	            }var j = setTimeout,
	                k = "function" == typeof _setImmediate3.default && _setImmediate3.default || function (a) {
	                j(a, 1);
	            },
	                l = Array.isArray || function (a) {
	                return "[object Array]" === Object.prototype.toString.call(a);
	            };c.prototype["catch"] = function (a) {
	                return this.then(null, a);
	            }, c.prototype.then = function (a, b) {
	                var e = this;return new c(function (c, f) {
	                    d.call(e, new h(a, b, c, f));
	                });
	            }, c.all = function () {
	                var a = Array.prototype.slice.call(1 === arguments.length && l(arguments[0]) ? arguments[0] : arguments);return new c(function (b, c) {
	                    function d(f, g) {
	                        try {
	                            if (g && ("object" == (typeof g === 'undefined' ? 'undefined' : (0, _typeof3.default)(g)) || "function" == typeof g)) {
	                                var h = g.then;if ("function" == typeof h) return void h.call(g, function (a) {
	                                    d(f, a);
	                                }, c);
	                            }a[f] = g, 0 === --e && b(a);
	                        } catch (i) {
	                            c(i);
	                        }
	                    }if (0 === a.length) return b([]);for (var e = a.length, f = 0; f < a.length; f++) {
	                        d(f, a[f]);
	                    }
	                });
	            }, c.resolve = function (a) {
	                return a && "object" == (typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a)) && a.constructor === c ? a : new c(function (b) {
	                    b(a);
	                });
	            }, c.reject = function (a) {
	                return new c(function (b, c) {
	                    c(a);
	                });
	            }, c.race = function (a) {
	                return new c(function (b, c) {
	                    for (var d = 0, e = a.length; e > d; d++) {
	                        a[d].then(b, c);
	                    }
	                });
	            }, c._setImmediateFn = function (a) {
	                k = a;
	            }, "undefined" != typeof module && module.exports ? module.exports = c : a.Promise || (a.Promise = c);
	        }(this);
	    }
	
	    if (typeof window.CustomEvent !== "function") {
	        (function () {
	            function CustomEvent(event, params) {
	                params = params || { bubbles: false, cancelable: false, detail: undefined };
	                var evt = document.createEvent('CustomEvent');
	                evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	                return evt;
	            }
	            CustomEvent.prototype = window.Event.prototype;
	            window.CustomEvent = CustomEvent;
	        })();
	    }
	
	    if (!HTMLCanvasElement.prototype.toBlob) {
	        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
	            value: function value(callback, type, quality) {
	                var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
	                    len = binStr.length,
	                    arr = new Uint8Array(len);
	
	                for (var i = 0; i < len; i++) {
	                    arr[i] = binStr.charCodeAt(i);
	                }
	
	                callback(new Blob([arr], { type: type || 'image/png' }));
	            }
	        });
	    }
	
	
	    var cssPrefixes = ['Webkit', 'Moz', 'ms'],
	        emptyStyles = document.createElement('div').style,
	        CSS_TRANS_ORG,
	        CSS_TRANSFORM,
	        CSS_USERSELECT;
	
	    function vendorPrefix(prop) {
	        if (prop in emptyStyles) {
	            return prop;
	        }
	
	        var capProp = prop[0].toUpperCase() + prop.slice(1),
	            i = cssPrefixes.length;
	
	        while (i--) {
	            prop = cssPrefixes[i] + capProp;
	            if (prop in emptyStyles) {
	                return prop;
	            }
	        }
	    }
	
	    CSS_TRANSFORM = vendorPrefix('transform');
	    CSS_TRANS_ORG = vendorPrefix('transformOrigin');
	    CSS_USERSELECT = vendorPrefix('userSelect');
	
	    function deepExtend(destination, source) {
	        destination = destination || {};
	        for (var property in source) {
	            if (source[property] && source[property].constructor && source[property].constructor === Object) {
	                destination[property] = destination[property] || {};
	                deepExtend(destination[property], source[property]);
	            } else {
	                destination[property] = source[property];
	            }
	        }
	        return destination;
	    }
	
	    function debounce(func, wait, immediate) {
	        var timeout;
	        return function () {
	            var context = this,
	                args = arguments;
	            var later = function later() {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    }
	
	    function dispatchChange(element) {
	        if ("createEvent" in document) {
	            var evt = document.createEvent("HTMLEvents");
	            evt.initEvent("change", false, true);
	            element.dispatchEvent(evt);
	        } else {
	            element.fireEvent("onchange");
	        }
	    }
	
	    function css(el, styles, val) {
	        if (typeof styles === 'string') {
	            var tmp = styles;
	            styles = {};
	            styles[tmp] = val;
	        }
	
	        for (var prop in styles) {
	            el.style[prop] = styles[prop];
	        }
	    }
	
	    function addClass(el, c) {
	        if (el.classList) {
	            el.classList.add(c);
	        } else {
	            el.className += ' ' + c;
	        }
	    }
	
	    function removeClass(el, c) {
	        if (el.classList) {
	            el.classList.remove(c);
	        } else {
	            el.className = el.className.replace(c, '');
	        }
	    }
	
	    function num(v) {
	        return parseInt(v, 10);
	    }
	
	    function loadImage(src, imageEl, useCanvas) {
	        var img = imageEl || new Image(),
	            prom;
	
	        if (img.src === src) {
	            prom = new _promise2.default(function (resolve, reject) {
	                resolve(img);
	            });
	        } else {
	            prom = new _promise2.default(function (resolve, reject) {
	                if (useCanvas && src.substring(0, 4).toLowerCase() === 'http') {
	                    img.setAttribute('crossOrigin', 'anonymous');
	                }
	                img.onload = function () {
	                    setTimeout(function () {
	                        resolve(img);
	                    }, 1);
	                };
	            });
	
	            img.src = src;
	        }
	
	        img.style.opacity = 0;
	
	        return prom;
	    }
	
	    var _TRANSLATE = 'translate3d',
	        _TRANSLATE_SUFFIX = ', 0px';
	    var Transform = function Transform(x, y, scale) {
	        this.x = parseFloat(x);
	        this.y = parseFloat(y);
	        this.scale = parseFloat(scale);
	    };
	
	    Transform.parse = function (v) {
	        if (v.style) {
	            return Transform.parse(v.style[CSS_TRANSFORM]);
	        } else if (v.indexOf('matrix') > -1 || v.indexOf('none') > -1) {
	            return Transform.fromMatrix(v);
	        } else {
	            return Transform.fromString(v);
	        }
	    };
	
	    Transform.fromMatrix = function (v) {
	        var vals = v.substring(7).split(',');
	        if (!vals.length || v === 'none') {
	            vals = [1, 0, 0, 1, 0, 0];
	        }
	
	        return new Transform(num(vals[4]), num(vals[5]), parseFloat(vals[0]));
	    };
	
	    Transform.fromString = function (v) {
	        var values = v.split(') '),
	            translate = values[0].substring(_TRANSLATE.length + 1).split(','),
	            scale = values.length > 1 ? values[1].substring(6) : 1,
	            x = translate.length > 1 ? translate[0] : 0,
	            y = translate.length > 1 ? translate[1] : 0;
	
	        return new Transform(x, y, scale);
	    };
	
	    Transform.prototype.toString = function () {
	        return _TRANSLATE + '(' + this.x + 'px, ' + this.y + 'px' + _TRANSLATE_SUFFIX + ') scale(' + this.scale + ')';
	    };
	
	    var TransformOrigin = function TransformOrigin(el) {
	        if (!el || !el.style[CSS_TRANS_ORG]) {
	            this.x = 0;
	            this.y = 0;
	            return;
	        }
	        var css = el.style[CSS_TRANS_ORG].split(' ');
	        this.x = parseFloat(css[0]);
	        this.y = parseFloat(css[1]);
	    };
	
	    TransformOrigin.prototype.toString = function () {
	        return this.x + 'px ' + this.y + 'px';
	    };
	
	    function getExifOrientation(img, cb) {
	        if (!window.EXIF) {
	            cb(0);
	        }
	
	        EXIF.getData(img, function () {
	            var orientation = EXIF.getTag(this, 'Orientation');
	            cb(orientation);
	        });
	    }
	
	    function drawCanvas(canvas, img, orientation) {
	        var width = img.width,
	            height = img.height,
	            ctx = canvas.getContext('2d');
	
	        canvas.width = img.width;
	        canvas.height = img.height;
	
	        ctx.save();
	        switch (orientation) {
	            case 2:
	                ctx.translate(width, 0);
	                ctx.scale(-1, 1);
	                break;
	
	            case 3:
	                ctx.translate(width, height);
	                ctx.rotate(180 * Math.PI / 180);
	                break;
	
	            case 4:
	                ctx.translate(0, height);
	                ctx.scale(1, -1);
	                break;
	
	            case 5:
	                canvas.width = height;
	                canvas.height = width;
	                ctx.rotate(90 * Math.PI / 180);
	                ctx.scale(1, -1);
	                break;
	
	            case 6:
	                canvas.width = height;
	                canvas.height = width;
	                ctx.rotate(90 * Math.PI / 180);
	                ctx.translate(0, -height);
	                break;
	
	            case 7:
	                canvas.width = height;
	                canvas.height = width;
	                ctx.rotate(-90 * Math.PI / 180);
	                ctx.translate(-width, height);
	                ctx.scale(1, -1);
	                break;
	
	            case 8:
	                canvas.width = height;
	                canvas.height = width;
	                ctx.translate(0, width);
	                ctx.rotate(-90 * Math.PI / 180);
	                break;
	        }
	        ctx.drawImage(img, 0, 0, width, height);
	        ctx.restore();
	    }
	
	    function _create() {
	        var self = this,
	            contClass = 'croppie-container',
	            customViewportClass = self.options.viewport.type ? 'cr-vp-' + self.options.viewport.type : null,
	            boundary,
	            img,
	            viewport,
	            overlay,
	            canvas,
	            bw,
	            bh;
	
	        self.options.useCanvas = self.options.enableOrientation || _hasExif.call(self);
	
	        self.data = {};
	        self.elements = {};
	
	        boundary = self.elements.boundary = document.createElement('div');
	        viewport = self.elements.viewport = document.createElement('div');
	        img = self.elements.img = document.createElement('img');
	        overlay = self.elements.overlay = document.createElement('div');
	
	        if (self.options.useCanvas) {
	            self.elements.canvas = document.createElement('canvas');
	            self.elements.preview = self.elements.canvas;
	        } else {
	            self.elements.preview = self.elements.img;
	        }
	
	        addClass(boundary, 'cr-boundary');
	        bw = self.options.boundary.width;
	        bh = self.options.boundary.height;
	        css(boundary, {
	            width: bw + (isNaN(bw) ? '' : 'px'),
	            height: bh + (isNaN(bh) ? '' : 'px')
	        });
	
	        addClass(viewport, 'cr-viewport');
	        if (customViewportClass) {
	            addClass(viewport, customViewportClass);
	        }
	        css(viewport, {
	            width: self.options.viewport.width + 'px',
	            height: self.options.viewport.height + 'px'
	        });
	        viewport.setAttribute('tabindex', 0);
	
	        addClass(self.elements.preview, 'cr-image');
	        addClass(overlay, 'cr-overlay');
	
	        self.element.appendChild(boundary);
	        boundary.appendChild(self.elements.preview);
	        boundary.appendChild(viewport);
	        boundary.appendChild(overlay);
	
	        addClass(self.element, contClass);
	        if (self.options.customClass) {
	            addClass(self.element, self.options.customClass);
	        }
	
	        _initDraggable.call(this);
	
	        if (self.options.enableZoom) {
	            _initializeZoom.call(self);
	        }
	    }
	
	    function _initRotationControls() {
	        return;
	        var self = this,
	            wrap,
	            btnLeft,
	            btnRight,
	            iLeft,
	            iRight;
	
	        wrap = document.createElement('div');
	        self.elements.orientationBtnLeft = btnLeft = document.createElement('button');
	        self.elements.orientationBtnRight = btnRight = document.createElement('button');
	
	        wrap.appendChild(btnLeft);
	        wrap.appendChild(btnRight);
	
	        iLeft = document.createElement('i');
	        iRight = document.createElement('i');
	        btnLeft.appendChild(iLeft);
	        btnRight.appendChild(iRight);
	
	        addClass(wrap, 'cr-rotate-controls');
	        addClass(btnLeft, 'cr-rotate-l');
	        addClass(btnRight, 'cr-rotate-r');
	
	        self.elements.boundary.appendChild(wrap);
	
	        btnLeft.addEventListener('click', function () {
	            self.rotate(-90);
	        });
	        btnRight.addEventListener('click', function () {
	            self.rotate(90);
	        });
	    }
	
	    function _hasExif() {
	        return this.options.enableExif && window.EXIF;
	    }
	
	    function _setZoomerVal(v) {
	        if (this.options.enableZoom) {
	            var z = this.elements.zoomer,
	                val = fix(v, 4);
	
	            z.value = Math.max(z.min, Math.min(z.max, val));
	        }
	    }
	
	    function _initializeZoom() {
	        var self = this,
	            wrap = self.elements.zoomerWrap = document.createElement('div'),
	            zoomer = self.elements.zoomer = document.createElement('input');
	
	        addClass(wrap, 'cr-slider-wrap');
	        addClass(zoomer, 'cr-slider');
	        zoomer.type = 'range';
	        zoomer.step = '0.0001';
	        zoomer.value = 1;
	        zoomer.style.display = self.options.showZoomer ? '' : 'none';
	
	        self.element.appendChild(wrap);
	        wrap.appendChild(zoomer);
	
	        self._currentZoom = 1;
	
	        function change() {
	            _onZoom.call(self, {
	                value: parseFloat(zoomer.value),
	                origin: new TransformOrigin(self.elements.preview),
	                viewportRect: self.elements.viewport.getBoundingClientRect(),
	                transform: Transform.parse(self.elements.preview)
	            });
	        }
	
	        function scroll(ev) {
	            var delta, targetZoom;
	
	            if (ev.wheelDelta) {
	                delta = ev.wheelDelta / 1200;
	            } else if (ev.deltaY) {
	                delta = ev.deltaY / 1060;
	            } else if (ev.detail) {
	                delta = ev.detail / -60;
	            } else {
	                delta = 0;
	            }
	
	            targetZoom = self._currentZoom + delta * self._currentZoom;
	
	            ev.preventDefault();
	            _setZoomerVal.call(self, targetZoom);
	            change.call(self);
	        }
	
	        self.elements.zoomer.addEventListener('input', change);
	        self.elements.zoomer.addEventListener('change', change);
	
	        if (self.options.mouseWheelZoom) {
	            self.elements.boundary.addEventListener('mousewheel', scroll);
	            self.elements.boundary.addEventListener('DOMMouseScroll', scroll);
	        }
	    }
	
	    function _onZoom(ui) {
	        var self = this,
	            transform = ui ? ui.transform : Transform.parse(self.elements.preview),
	            vpRect = ui ? ui.viewportRect : self.elements.viewport.getBoundingClientRect(),
	            origin = ui ? ui.origin : new TransformOrigin(self.elements.preview),
	            transCss = {};
	
	        function applyCss() {
	            var transCss = {};
	            transCss[CSS_TRANSFORM] = transform.toString();
	            transCss[CSS_TRANS_ORG] = origin.toString();
	            css(self.elements.preview, transCss);
	        }
	
	        self._currentZoom = ui ? ui.value : self._currentZoom;
	        transform.scale = self._currentZoom;
	        applyCss();
	
	        if (self.options.enforceBoundary) {
	            var boundaries = _getVirtualBoundaries.call(self, vpRect),
	                transBoundaries = boundaries.translate,
	                oBoundaries = boundaries.origin;
	
	            if (transform.x >= transBoundaries.maxX) {
	                origin.x = oBoundaries.minX;
	                transform.x = transBoundaries.maxX;
	            }
	
	            if (transform.x <= transBoundaries.minX) {
	                origin.x = oBoundaries.maxX;
	                transform.x = transBoundaries.minX;
	            }
	
	            if (transform.y >= transBoundaries.maxY) {
	                origin.y = oBoundaries.minY;
	                transform.y = transBoundaries.maxY;
	            }
	
	            if (transform.y <= transBoundaries.minY) {
	                origin.y = oBoundaries.maxY;
	                transform.y = transBoundaries.minY;
	            }
	        }
	        applyCss();
	        _debouncedOverlay.call(self);
	        _triggerUpdate.call(self);
	    }
	
	    function _getVirtualBoundaries(viewport) {
	        var self = this,
	            scale = self._currentZoom,
	            vpWidth = viewport.width,
	            vpHeight = viewport.height,
	            centerFromBoundaryX = self.elements.boundary.clientWidth / 2,
	            centerFromBoundaryY = self.elements.boundary.clientHeight / 2,
	            imgRect = self.elements.preview.getBoundingClientRect(),
	            curImgWidth = imgRect.width,
	            curImgHeight = imgRect.height,
	            halfWidth = vpWidth / 2,
	            halfHeight = vpHeight / 2;
	
	        var maxX = (halfWidth / scale - centerFromBoundaryX) * -1;
	        var minX = maxX - (curImgWidth * (1 / scale) - vpWidth * (1 / scale));
	
	        var maxY = (halfHeight / scale - centerFromBoundaryY) * -1;
	        var minY = maxY - (curImgHeight * (1 / scale) - vpHeight * (1 / scale));
	
	        var originMinX = 1 / scale * halfWidth;
	        var originMaxX = curImgWidth * (1 / scale) - originMinX;
	
	        var originMinY = 1 / scale * halfHeight;
	        var originMaxY = curImgHeight * (1 / scale) - originMinY;
	
	        return {
	            translate: {
	                maxX: maxX,
	                minX: minX,
	                maxY: maxY,
	                minY: minY
	            },
	            origin: {
	                maxX: originMaxX,
	                minX: originMinX,
	                maxY: originMaxY,
	                minY: originMinY
	            }
	        };
	    }
	
	    function _updateCenterPoint() {
	        var self = this,
	            scale = self._currentZoom,
	            data = self.elements.preview.getBoundingClientRect(),
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            transform = Transform.parse(self.elements.preview.style[CSS_TRANSFORM]),
	            pc = new TransformOrigin(self.elements.preview),
	            top = vpData.top - data.top + vpData.height / 2,
	            left = vpData.left - data.left + vpData.width / 2,
	            center = {},
	            adj = {};
	
	        center.y = top / scale;
	        center.x = left / scale;
	
	        adj.y = (center.y - pc.y) * (1 - scale);
	        adj.x = (center.x - pc.x) * (1 - scale);
	
	        transform.x -= adj.x;
	        transform.y -= adj.y;
	
	        var newCss = {};
	        newCss[CSS_TRANS_ORG] = center.x + 'px ' + center.y + 'px';
	        newCss[CSS_TRANSFORM] = transform.toString();
	        css(self.elements.preview, newCss);
	    }
	
	    function _initDraggable() {
	        var self = this,
	            isDragging = false,
	            originalX,
	            originalY,
	            originalDistance,
	            vpRect,
	            transform;
	
	        function assignTransformCoordinates(deltaX, deltaY) {
	            var imgRect = self.elements.preview.getBoundingClientRect(),
	                top = transform.y + deltaY,
	                left = transform.x + deltaX;
	
	            if (self.options.enforceBoundary) {
	                if (vpRect.top > imgRect.top + deltaY && vpRect.bottom < imgRect.bottom + deltaY) {
	                    transform.y = top;
	                }
	
	                if (vpRect.left > imgRect.left + deltaX && vpRect.right < imgRect.right + deltaX) {
	                    transform.x = left;
	                }
	            } else {
	                transform.y = top;
	                transform.x = left;
	            }
	        }
	
	        function keyDown(ev) {
	            var LEFT_ARROW = 37,
	                UP_ARROW = 38,
	                RIGHT_ARROW = 39,
	                DOWN_ARROW = 40;
	
	            if (ev.shiftKey && (ev.keyCode == UP_ARROW || ev.keyCode == DOWN_ARROW)) {
	                var zoom = 0.0;
	                if (ev.keyCode == UP_ARROW) {
	                    zoom = parseFloat(self.elements.zoomer.value, 10) + parseFloat(self.elements.zoomer.step, 10);
	                } else {
	                    zoom = parseFloat(self.elements.zoomer.value, 10) - parseFloat(self.elements.zoomer.step, 10);
	                }
	                self.setZoom(zoom);
	            } else if (ev.keyCode >= 37 && ev.keyCode <= 40) {
	                ev.preventDefault();
	                var movement = parseKeyDown(ev.keyCode);
	
	                transform = Transform.parse(self.elements.preview);
	                document.body.style[CSS_USERSELECT] = 'none';
	                vpRect = self.elements.viewport.getBoundingClientRect();
	                keyMove(movement);
	            };
	
	            function parseKeyDown(key) {
	                switch (key) {
	                    case LEFT_ARROW:
	                        return [1, 0];
	                    case UP_ARROW:
	                        return [0, 1];
	                    case RIGHT_ARROW:
	                        return [-1, 0];
	                    case DOWN_ARROW:
	                        return [0, -1];
	                };
	            };
	        }
	
	        function keyMove(movement) {
	            var deltaX = movement[0],
	                deltaY = movement[1],
	                newCss = {};
	
	            assignTransformCoordinates(deltaX, deltaY);
	
	            newCss[CSS_TRANSFORM] = transform.toString();
	            css(self.elements.preview, newCss);
	            _updateOverlay.call(self);
	            document.body.style[CSS_USERSELECT] = '';
	            _updateCenterPoint.call(self);
	            _triggerUpdate.call(self);
	            originalDistance = 0;
	        }
	
	        function mouseDown(ev) {
	            ev.preventDefault();
	            if (isDragging) return;
	            isDragging = true;
	            originalX = ev.pageX;
	            originalY = ev.pageY;
	
	            if (ev.touches) {
	                var touches = ev.touches[0];
	                originalX = touches.pageX;
	                originalY = touches.pageY;
	            }
	
	            transform = Transform.parse(self.elements.preview);
	            window.addEventListener('mousemove', mouseMove);
	            window.addEventListener('touchmove', mouseMove);
	            window.addEventListener('mouseup', mouseUp);
	            window.addEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = 'none';
	            vpRect = self.elements.viewport.getBoundingClientRect();
	        }
	
	        function mouseMove(ev) {
	            ev.preventDefault();
	            var pageX = ev.pageX,
	                pageY = ev.pageY;
	
	            if (ev.touches) {
	                var touches = ev.touches[0];
	                pageX = touches.pageX;
	                pageY = touches.pageY;
	            }
	
	            var deltaX = pageX - originalX,
	                deltaY = pageY - originalY,
	                newCss = {};
	
	            if (ev.type == 'touchmove') {
	                if (ev.touches.length > 1) {
	                    var touch1 = ev.touches[0];
	                    var touch2 = ev.touches[1];
	                    var dist = Math.sqrt((touch1.pageX - touch2.pageX) * (touch1.pageX - touch2.pageX) + (touch1.pageY - touch2.pageY) * (touch1.pageY - touch2.pageY));
	
	                    if (!originalDistance) {
	                        originalDistance = dist / self._currentZoom;
	                    }
	
	                    var scale = dist / originalDistance;
	
	                    _setZoomerVal.call(self, scale);
	                    dispatchChange(self.elements.zoomer);
	                    return;
	                }
	            }
	
	            assignTransformCoordinates(deltaX, deltaY);
	
	            newCss[CSS_TRANSFORM] = transform.toString();
	            css(self.elements.preview, newCss);
	            _updateOverlay.call(self);
	            originalY = pageY;
	            originalX = pageX;
	        }
	
	        function mouseUp() {
	            isDragging = false;
	            window.removeEventListener('mousemove', mouseMove);
	            window.removeEventListener('touchmove', mouseMove);
	            window.removeEventListener('mouseup', mouseUp);
	            window.removeEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = '';
	            _updateCenterPoint.call(self);
	            _triggerUpdate.call(self);
	            originalDistance = 0;
	        }
	
	        self.elements.overlay.addEventListener('mousedown', mouseDown);
	        self.elements.viewport.addEventListener('keydown', keyDown);
	        self.elements.overlay.addEventListener('touchstart', mouseDown);
	    }
	
	    function _updateOverlay() {
	        var self = this,
	            boundRect = self.elements.boundary.getBoundingClientRect(),
	            imgData = self.elements.preview.getBoundingClientRect();
	
	        css(self.elements.overlay, {
	            width: imgData.width + 'px',
	            height: imgData.height + 'px',
	            top: imgData.top - boundRect.top + 'px',
	            left: imgData.left - boundRect.left + 'px'
	        });
	    }
	    var _debouncedOverlay = debounce(_updateOverlay, 500);
	
	    function _triggerUpdate() {
	        var self = this,
	            data = self.get(),
	            ev;
	
	        if (!_isVisible.call(self)) {
	            return;
	        }
	
	        self.options.update.call(self, data);
	        if (self.$) {
	            self.$(self.element).trigger('update', data);
	        } else {
	            var ev;
	            if (window.CustomEvent) {
	                ev = new CustomEvent('update', { detail: data });
	            } else {
	                ev = document.createEvent('CustomEvent');
	                ev.initCustomEvent('update', true, true, data);
	            }
	
	            self.element.dispatchEvent(ev);
	        }
	    }
	
	    function _isVisible() {
	        return this.elements.preview.offsetHeight > 0 && this.elements.preview.offsetWidth > 0;
	    }
	
	    function _updatePropertiesFromImage() {
	        var self = this,
	            minZoom = 0,
	            maxZoom = 1.5,
	            initialZoom = 1,
	            cssReset = {},
	            img = self.elements.preview,
	            zoomer = self.elements.zoomer,
	            transformReset = new Transform(0, 0, initialZoom),
	            originReset = new TransformOrigin(),
	            isVisible = _isVisible.call(self),
	            imgData,
	            vpData,
	            boundaryData,
	            minW,
	            minH;
	
	        if (!isVisible || self.data.bound) {
	            return;
	        }
	
	        self.data.bound = true;
	        cssReset[CSS_TRANSFORM] = transformReset.toString();
	        cssReset[CSS_TRANS_ORG] = originReset.toString();
	        cssReset['opacity'] = 1;
	        css(img, cssReset);
	
	        imgData = img.getBoundingClientRect();
	        vpData = self.elements.viewport.getBoundingClientRect();
	        boundaryData = self.elements.boundary.getBoundingClientRect();
	        self._originalImageWidth = imgData.width;
	        self._originalImageHeight = imgData.height;
	
	        if (self.options.enableZoom) {
	            if (self.options.enforceBoundary) {
	                minW = vpData.width / imgData.width;
	                minH = vpData.height / imgData.height;
	                minZoom = Math.max(minW, minH);
	            }
	
	            if (minZoom >= maxZoom) {
	                maxZoom = minZoom + 1;
	            }
	
	            zoomer.min = fix(minZoom, 4);
	            zoomer.max = fix(maxZoom, 4);
	            var defaultInitialZoom = Math.max(boundaryData.width / imgData.width, boundaryData.height / imgData.height);
	            initialZoom = self.data.boundZoom !== null ? self.data.boundZoom : defaultInitialZoom;
	            _setZoomerVal.call(self, initialZoom);
	            dispatchChange(zoomer);
	        } else {
	            self._currentZoom = initialZoom;
	        }
	
	        transformReset.scale = self._currentZoom;
	        cssReset[CSS_TRANSFORM] = transformReset.toString();
	        css(img, cssReset);
	
	        if (self.data.points.length) {
	            _bindPoints.call(self, self.data.points);
	        } else {
	            _centerImage.call(self);
	        }
	
	        _updateCenterPoint.call(self);
	        _updateOverlay.call(self);
	    }
	
	    function _bindPoints(points) {
	        if (points.length != 4) {
	            throw "Croppie - Invalid number of points supplied: " + points;
	        }
	        var self = this,
	            pointsWidth = points[2] - points[0],
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            boundRect = self.elements.boundary.getBoundingClientRect(),
	            vpOffset = {
	            left: vpData.left - boundRect.left,
	            top: vpData.top - boundRect.top
	        },
	            scale = vpData.width / pointsWidth,
	            originTop = points[1],
	            originLeft = points[0],
	            transformTop = -1 * points[1] + vpOffset.top,
	            transformLeft = -1 * points[0] + vpOffset.left,
	            newCss = {};
	
	        newCss[CSS_TRANS_ORG] = originLeft + 'px ' + originTop + 'px';
	        newCss[CSS_TRANSFORM] = new Transform(transformLeft, transformTop, scale).toString();
	        css(self.elements.preview, newCss);
	
	        _setZoomerVal.call(self, scale);
	        self._currentZoom = scale;
	    }
	
	    function _centerImage() {
	        var self = this,
	            imgDim = self.elements.preview.getBoundingClientRect(),
	            vpDim = self.elements.viewport.getBoundingClientRect(),
	            boundDim = self.elements.boundary.getBoundingClientRect(),
	            vpLeft = vpDim.left - boundDim.left,
	            vpTop = vpDim.top - boundDim.top,
	            w = vpLeft - (imgDim.width - vpDim.width) / 2,
	            h = vpTop - (imgDim.height - vpDim.height) / 2,
	            transform = new Transform(w, h, self._currentZoom);
	
	        css(self.elements.preview, CSS_TRANSFORM, transform.toString());
	    }
	
	    function _transferImageToCanvas(customOrientation) {
	        var self = this,
	            canvas = self.elements.canvas,
	            img = self.elements.img,
	            ctx = canvas.getContext('2d'),
	            exif = _hasExif.call(self),
	            customOrientation = self.options.enableOrientation && customOrientation;
	
	        ctx.clearRect(0, 0, canvas.width, canvas.height);
	        canvas.width = img.width;
	        canvas.height = img.height;
	
	        if (exif) {
	            getExifOrientation(img, function (orientation) {
	                drawCanvas(canvas, img, num(orientation, 10));
	                if (customOrientation) {
	                    drawCanvas(canvas, img, customOrientation);
	                }
	            });
	        } else if (customOrientation) {
	            drawCanvas(canvas, img, customOrientation);
	        }
	    }
	
	    function _getCanvas(data) {
	        var self = this,
	            points = data.points,
	            left = num(points[0]),
	            top = num(points[1]),
	            width = points[2] - points[0],
	            height = points[3] - points[1],
	            circle = data.circle,
	            canvas = document.createElement('canvas'),
	            ctx = canvas.getContext('2d'),
	            outWidth = width,
	            outHeight = height,
	            startX = 0,
	            startY = 0;
	
	        if (data.outputWidth && data.outputHeight) {
	            outWidth = data.outputWidth;
	            outHeight = data.outputHeight;
	        }
	
	        canvas.width = outWidth;
	        canvas.height = outHeight;
	
	        if (data.backgroundColor) {
	            ctx.fillStyle = data.backgroundColor;
	            ctx.fillRect(0, 0, outWidth, outHeight);
	        }
	
	        if (left < 0) {
	            startX = Math.abs(left);
	            left = 0;
	        }
	        if (top < 0) {
	            startY = Math.abs(top);
	            top = 0;
	        }
	        if (left + width > self._originalImageWidth) {
	            width = self._originalImageWidth - left;
	            outWidth = width;
	        }
	        if (top + height > self._originalImageHeight) {
	            height = self._originalImageHeight - top;
	            outHeight = height;
	        }
	
	        ctx.drawImage(this.elements.preview, left, top, width, height, startX, startY, outWidth, outHeight);
	        if (circle) {
	            ctx.fillStyle = '#fff';
	            ctx.globalCompositeOperation = 'destination-in';
	            ctx.beginPath();
	            ctx.arc(outWidth / 2, outHeight / 2, outWidth / 2, 0, Math.PI * 2, true);
	            ctx.closePath();
	            ctx.fill();
	        }
	        return canvas;
	    }
	
	    function _getHtmlResult(data) {
	        var points = data.points,
	            div = document.createElement('div'),
	            img = document.createElement('img'),
	            width = points[2] - points[0],
	            height = points[3] - points[1];
	
	        addClass(div, 'croppie-result');
	        div.appendChild(img);
	        css(img, {
	            left: -1 * points[0] + 'px',
	            top: -1 * points[1] + 'px'
	        });
	        img.src = data.url;
	        css(div, {
	            width: width + 'px',
	            height: height + 'px'
	        });
	
	        return div;
	    }
	
	    function _getBase64Result(data) {
	        return _getCanvas.call(this, data).toDataURL(data.format, data.quality);
	    }
	
	    function _getBlobResult(data) {
	        var self = this;
	        return new _promise2.default(function (resolve, reject) {
	            _getCanvas.call(self, data).toBlob(function (blob) {
	                resolve(blob);
	            }, data.format, data.quality);
	        });
	    }
	
	    function _bind(options, cb) {
	        var self = this,
	            url,
	            points = [],
	            zoom = null;
	
	        if (typeof options === 'string') {
	            url = options;
	            options = {};
	        } else if (Array.isArray(options)) {
	            points = options.slice();
	        } else if (typeof options == 'undefined' && self.data.url) {
	            _updatePropertiesFromImage.call(self);
	            _triggerUpdate.call(self);
	            return null;
	        } else {
	            url = options.url;
	            points = options.points || [];
	            zoom = typeof options.zoom === 'undefined' ? null : options.zoom;
	        }
	
	        self.data.bound = false;
	        self.data.url = url || self.data.url;
	        self.data.points = (points || self.data.points).map(function (p) {
	            return parseFloat(p);
	        });
	        self.data.boundZoom = zoom;
	        var prom = loadImage(url, self.elements.img, self.options.useCanvas);
	        prom.then(function () {
	            if (self.options.useCanvas) {
	                self.elements.img.exifdata = null;
	                _transferImageToCanvas.call(self, options.orientation || 1);
	            }
	            _updatePropertiesFromImage.call(self);
	            _triggerUpdate.call(self);
	            if (cb) {
	                cb();
	            }
	        });
	        return prom;
	    }
	
	    function fix(v, decimalPoints) {
	        return parseFloat(v).toFixed(decimalPoints || 0);
	    }
	
	    function _get() {
	        var self = this,
	            imgData = self.elements.preview.getBoundingClientRect(),
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            x1 = vpData.left - imgData.left,
	            y1 = vpData.top - imgData.top,
	            widthDiff = (vpData.width - self.elements.viewport.offsetWidth) / 2,
	            heightDiff = (vpData.height - self.elements.viewport.offsetHeight) / 2,
	            x2 = x1 + self.elements.viewport.offsetWidth + widthDiff,
	            y2 = y1 + self.elements.viewport.offsetHeight + heightDiff,
	            scale = self._currentZoom;
	
	        if (scale === Infinity || isNaN(scale)) {
	            scale = 1;
	        }
	
	        var max = self.options.enforceBoundary ? 0 : Number.NEGATIVE_INFINITY;
	        x1 = Math.max(max, x1 / scale);
	        y1 = Math.max(max, y1 / scale);
	        x2 = Math.max(max, x2 / scale);
	        y2 = Math.max(max, y2 / scale);
	
	        return {
	            points: [fix(x1), fix(y1), fix(x2), fix(y2)],
	            zoom: scale
	        };
	    }
	
	    var RESULT_DEFAULTS = {
	        type: 'canvas',
	        format: 'png',
	        quality: 1
	    },
	        RESULT_FORMATS = ['jpeg', 'webp', 'png'];
	
	    function _result(options) {
	        var self = this,
	            data = _get.call(self),
	            opts = deepExtend(RESULT_DEFAULTS, deepExtend({}, options)),
	            resultType = typeof options === 'string' ? options : opts.type || 'base64',
	            size = opts.size,
	            format = opts.format,
	            quality = opts.quality,
	            backgroundColor = opts.backgroundColor,
	            circle = typeof opts.circle === 'boolean' ? opts.circle : self.options.viewport.type === 'circle',
	            vpRect = self.elements.viewport.getBoundingClientRect(),
	            ratio = vpRect.width / vpRect.height,
	            prom;
	
	        if (size === 'viewport') {
	            data.outputWidth = vpRect.width;
	            data.outputHeight = vpRect.height;
	        } else if ((typeof size === 'undefined' ? 'undefined' : (0, _typeof3.default)(size)) === 'object') {
	            if (size.width && size.height) {
	                data.outputWidth = size.width;
	                data.outputHeight = size.height;
	            } else if (size.width) {
	                data.outputWidth = size.width;
	                data.outputHeight = size.width / ratio;
	            } else if (size.height) {
	                data.outputWidth = size.height * ratio;
	                data.outputHeight = size.height;
	            }
	        }
	
	        if (RESULT_FORMATS.indexOf(format) > -1) {
	            data.format = 'image/' + format;
	            data.quality = quality;
	        }
	
	        data.circle = circle;
	        data.url = self.data.url;
	        data.backgroundColor = backgroundColor;
	
	        prom = new _promise2.default(function (resolve, reject) {
	            switch (resultType.toLowerCase()) {
	                case 'rawcanvas':
	                    resolve(_getCanvas.call(self, data));
	                    break;
	                case 'canvas':
	                case 'base64':
	                    resolve(_getBase64Result.call(self, data));
	                    break;
	                case 'blob':
	                    _getBlobResult.call(self, data).then(resolve);
	                    break;
	                default:
	                    resolve(_getHtmlResult.call(self, data));
	                    break;
	            }
	        });
	        return prom;
	    }
	
	    function _refresh() {
	        _updatePropertiesFromImage.call(this);
	    }
	
	    function _rotate(deg) {
	        if (!this.options.useCanvas) {
	            throw 'Croppie: Cannot rotate without enableOrientation';
	        }
	
	        var self = this,
	            canvas = self.elements.canvas,
	            img = self.elements.img,
	            copy = document.createElement('canvas'),
	            ornt = 1;
	
	        copy.width = canvas.width;
	        copy.height = canvas.height;
	        var ctx = copy.getContext('2d');
	        ctx.drawImage(canvas, 0, 0);
	
	        if (deg === 90 || deg === -270) ornt = 6;
	        if (deg === -90 || deg === 270) ornt = 8;
	        if (deg === 180 || deg === -180) ornt = 3;
	
	        drawCanvas(canvas, copy, ornt);
	        _onZoom.call(self);
	    }
	
	    function _destroy() {
	        var self = this;
	        self.element.removeChild(self.elements.boundary);
	        removeClass(self.element, 'croppie-container');
	        if (self.options.enableZoom) {
	            self.element.removeChild(self.elements.zoomerWrap);
	        }
	        delete self.elements;
	    }
	
	    if (window.jQuery) {
	        var $ = window.jQuery;
	        $.fn.croppie = function (opts) {
	            var ot = typeof opts === 'undefined' ? 'undefined' : (0, _typeof3.default)(opts);
	
	            if (ot === 'string') {
	                var args = Array.prototype.slice.call(arguments, 1);
	                var singleInst = $(this).data('croppie');
	
	                if (opts === 'get') {
	                    return singleInst.get();
	                } else if (opts === 'result') {
	                    return singleInst.result.apply(singleInst, args);
	                } else if (opts === 'bind') {
	                    return singleInst.bind.apply(singleInst, args);
	                }
	
	                return this.each(function () {
	                    var i = $(this).data('croppie');
	                    if (!i) return;
	
	                    var method = i[opts];
	                    if ($.isFunction(method)) {
	                        method.apply(i, args);
	                        if (opts === 'destroy') {
	                            $(this).removeData('croppie');
	                        }
	                    } else {
	                        throw 'Croppie ' + opts + ' method not found';
	                    }
	                });
	            } else {
	                return this.each(function () {
	                    var i = new Croppie(this, opts);
	                    i.$ = $;
	                    $(this).data('croppie', i);
	                });
	            }
	        };
	    }
	
	    function Croppie(element, opts) {
	        this.element = element;
	        this.options = deepExtend(deepExtend({}, Croppie.defaults), opts);
	
	        if (this.element.tagName.toLowerCase() === 'img') {
	            var origImage = this.element;
	            addClass(origImage, 'cr-original-image');
	            var replacementDiv = document.createElement('div');
	            this.element.parentNode.appendChild(replacementDiv);
	            replacementDiv.appendChild(origImage);
	            this.element = replacementDiv;
	            this.options.url = this.options.url || origImage.src;
	        }
	
	        _create.call(this);
	        if (this.options.url) {
	            var bindOpts = {
	                url: this.options.url,
	                points: this.options.points
	            };
	            delete this.options['url'];
	            delete this.options['points'];
	            _bind.call(this, bindOpts);
	        }
	    }
	
	    Croppie.defaults = {
	        viewport: {
	            width: 100,
	            height: 100,
	            type: 'square'
	        },
	        boundary: {},
	        orientationControls: {
	            enabled: true,
	            leftClass: '',
	            rightClass: ''
	        },
	        customClass: '',
	        showZoomer: true,
	        enableZoom: true,
	        mouseWheelZoom: true,
	        enableExif: false,
	        enforceBoundary: true,
	        enableOrientation: false,
	        update: function update() {}
	    };
	
	    deepExtend(Croppie.prototype, {
	        bind: function bind(options, cb) {
	            return _bind.call(this, options, cb);
	        },
	        get: function get() {
	            return _get.call(this);
	        },
	        result: function result(type) {
	            return _result.call(this, type);
	        },
	        refresh: function refresh() {
	            return _refresh.call(this);
	        },
	        setZoom: function setZoom(v) {
	            _setZoomerVal.call(this, v);
	            dispatchChange(this.elements.zoomer);
	        },
	        rotate: function rotate(deg) {
	            _rotate.call(this, deg);
	        },
	        destroy: function destroy() {
	            return _destroy.call(this);
	        }
	    });
	
	    exports.Croppie = window.Croppie = Croppie;
	
	    if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && !!module.exports) {
	        module.exports = Croppie;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(129)(module)))

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof2 = __webpack_require__(39);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
	
	    var debug = false;
	
	    var root = this;
	
	    var EXIF = function EXIF(obj) {
	        if (obj instanceof EXIF) return obj;
	        if (!(this instanceof EXIF)) return new EXIF(obj);
	        this.EXIFwrapped = obj;
	    };
	
	    if (true) {
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = EXIF;
	        }
	        exports.EXIF = EXIF;
	    } else {
	        root.EXIF = EXIF;
	    }
	
	    var ExifTags = EXIF.Tags = {
	        0x9000: "ExifVersion",
	        0xA000: "FlashpixVersion",
	        0xA001: "ColorSpace",
	        0xA002: "PixelXDimension",
	        0xA003: "PixelYDimension",
	        0x9101: "ComponentsConfiguration",
	        0x9102: "CompressedBitsPerPixel",
	        0x927C: "MakerNote",
	        0x9286: "UserComment",
	        0xA004: "RelatedSoundFile",
	        0x9003: "DateTimeOriginal",
	        0x9004: "DateTimeDigitized",
	        0x9290: "SubsecTime",
	        0x9291: "SubsecTimeOriginal",
	        0x9292: "SubsecTimeDigitized",
	        0x829A: "ExposureTime",
	        0x829D: "FNumber",
	        0x8822: "ExposureProgram",
	        0x8824: "SpectralSensitivity",
	        0x8827: "ISOSpeedRatings",
	        0x8828: "OECF",
	        0x9201: "ShutterSpeedValue",
	        0x9202: "ApertureValue",
	        0x9203: "BrightnessValue",
	        0x9204: "ExposureBias",
	        0x9205: "MaxApertureValue",
	        0x9206: "SubjectDistance",
	        0x9207: "MeteringMode",
	        0x9208: "LightSource",
	        0x9209: "Flash",
	        0x9214: "SubjectArea",
	        0x920A: "FocalLength",
	        0xA20B: "FlashEnergy",
	        0xA20C: "SpatialFrequencyResponse",
	        0xA20E: "FocalPlaneXResolution",
	        0xA20F: "FocalPlaneYResolution",
	        0xA210: "FocalPlaneResolutionUnit",
	        0xA214: "SubjectLocation",
	        0xA215: "ExposureIndex",
	        0xA217: "SensingMethod",
	        0xA300: "FileSource",
	        0xA301: "SceneType",
	        0xA302: "CFAPattern",
	        0xA401: "CustomRendered",
	        0xA402: "ExposureMode",
	        0xA403: "WhiteBalance",
	        0xA404: "DigitalZoomRation",
	        0xA405: "FocalLengthIn35mmFilm",
	        0xA406: "SceneCaptureType",
	        0xA407: "GainControl",
	        0xA408: "Contrast",
	        0xA409: "Saturation",
	        0xA40A: "Sharpness",
	        0xA40B: "DeviceSettingDescription",
	        0xA40C: "SubjectDistanceRange",
	        0xA005: "InteroperabilityIFDPointer",
	        0xA420: "ImageUniqueID" };
	
	    var TiffTags = EXIF.TiffTags = {
	        0x0100: "ImageWidth",
	        0x0101: "ImageHeight",
	        0x8769: "ExifIFDPointer",
	        0x8825: "GPSInfoIFDPointer",
	        0xA005: "InteroperabilityIFDPointer",
	        0x0102: "BitsPerSample",
	        0x0103: "Compression",
	        0x0106: "PhotometricInterpretation",
	        0x0112: "Orientation",
	        0x0115: "SamplesPerPixel",
	        0x011C: "PlanarConfiguration",
	        0x0212: "YCbCrSubSampling",
	        0x0213: "YCbCrPositioning",
	        0x011A: "XResolution",
	        0x011B: "YResolution",
	        0x0128: "ResolutionUnit",
	        0x0111: "StripOffsets",
	        0x0116: "RowsPerStrip",
	        0x0117: "StripByteCounts",
	        0x0201: "JPEGInterchangeFormat",
	        0x0202: "JPEGInterchangeFormatLength",
	        0x012D: "TransferFunction",
	        0x013E: "WhitePoint",
	        0x013F: "PrimaryChromaticities",
	        0x0211: "YCbCrCoefficients",
	        0x0214: "ReferenceBlackWhite",
	        0x0132: "DateTime",
	        0x010E: "ImageDescription",
	        0x010F: "Make",
	        0x0110: "Model",
	        0x0131: "Software",
	        0x013B: "Artist",
	        0x8298: "Copyright"
	    };
	
	    var GPSTags = EXIF.GPSTags = {
	        0x0000: "GPSVersionID",
	        0x0001: "GPSLatitudeRef",
	        0x0002: "GPSLatitude",
	        0x0003: "GPSLongitudeRef",
	        0x0004: "GPSLongitude",
	        0x0005: "GPSAltitudeRef",
	        0x0006: "GPSAltitude",
	        0x0007: "GPSTimeStamp",
	        0x0008: "GPSSatellites",
	        0x0009: "GPSStatus",
	        0x000A: "GPSMeasureMode",
	        0x000B: "GPSDOP",
	        0x000C: "GPSSpeedRef",
	        0x000D: "GPSSpeed",
	        0x000E: "GPSTrackRef",
	        0x000F: "GPSTrack",
	        0x0010: "GPSImgDirectionRef",
	        0x0011: "GPSImgDirection",
	        0x0012: "GPSMapDatum",
	        0x0013: "GPSDestLatitudeRef",
	        0x0014: "GPSDestLatitude",
	        0x0015: "GPSDestLongitudeRef",
	        0x0016: "GPSDestLongitude",
	        0x0017: "GPSDestBearingRef",
	        0x0018: "GPSDestBearing",
	        0x0019: "GPSDestDistanceRef",
	        0x001A: "GPSDestDistance",
	        0x001B: "GPSProcessingMethod",
	        0x001C: "GPSAreaInformation",
	        0x001D: "GPSDateStamp",
	        0x001E: "GPSDifferential"
	    };
	
	    var StringValues = EXIF.StringValues = {
	        ExposureProgram: {
	            0: "Not defined",
	            1: "Manual",
	            2: "Normal program",
	            3: "Aperture priority",
	            4: "Shutter priority",
	            5: "Creative program",
	            6: "Action program",
	            7: "Portrait mode",
	            8: "Landscape mode"
	        },
	        MeteringMode: {
	            0: "Unknown",
	            1: "Average",
	            2: "CenterWeightedAverage",
	            3: "Spot",
	            4: "MultiSpot",
	            5: "Pattern",
	            6: "Partial",
	            255: "Other"
	        },
	        LightSource: {
	            0: "Unknown",
	            1: "Daylight",
	            2: "Fluorescent",
	            3: "Tungsten (incandescent light)",
	            4: "Flash",
	            9: "Fine weather",
	            10: "Cloudy weather",
	            11: "Shade",
	            12: "Daylight fluorescent (D 5700 - 7100K)",
	            13: "Day white fluorescent (N 4600 - 5400K)",
	            14: "Cool white fluorescent (W 3900 - 4500K)",
	            15: "White fluorescent (WW 3200 - 3700K)",
	            17: "Standard light A",
	            18: "Standard light B",
	            19: "Standard light C",
	            20: "D55",
	            21: "D65",
	            22: "D75",
	            23: "D50",
	            24: "ISO studio tungsten",
	            255: "Other"
	        },
	        Flash: {
	            0x0000: "Flash did not fire",
	            0x0001: "Flash fired",
	            0x0005: "Strobe return light not detected",
	            0x0007: "Strobe return light detected",
	            0x0009: "Flash fired, compulsory flash mode",
	            0x000D: "Flash fired, compulsory flash mode, return light not detected",
	            0x000F: "Flash fired, compulsory flash mode, return light detected",
	            0x0010: "Flash did not fire, compulsory flash mode",
	            0x0018: "Flash did not fire, auto mode",
	            0x0019: "Flash fired, auto mode",
	            0x001D: "Flash fired, auto mode, return light not detected",
	            0x001F: "Flash fired, auto mode, return light detected",
	            0x0020: "No flash function",
	            0x0041: "Flash fired, red-eye reduction mode",
	            0x0045: "Flash fired, red-eye reduction mode, return light not detected",
	            0x0047: "Flash fired, red-eye reduction mode, return light detected",
	            0x0049: "Flash fired, compulsory flash mode, red-eye reduction mode",
	            0x004D: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
	            0x004F: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
	            0x0059: "Flash fired, auto mode, red-eye reduction mode",
	            0x005D: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
	            0x005F: "Flash fired, auto mode, return light detected, red-eye reduction mode"
	        },
	        SensingMethod: {
	            1: "Not defined",
	            2: "One-chip color area sensor",
	            3: "Two-chip color area sensor",
	            4: "Three-chip color area sensor",
	            5: "Color sequential area sensor",
	            7: "Trilinear sensor",
	            8: "Color sequential linear sensor"
	        },
	        SceneCaptureType: {
	            0: "Standard",
	            1: "Landscape",
	            2: "Portrait",
	            3: "Night scene"
	        },
	        SceneType: {
	            1: "Directly photographed"
	        },
	        CustomRendered: {
	            0: "Normal process",
	            1: "Custom process"
	        },
	        WhiteBalance: {
	            0: "Auto white balance",
	            1: "Manual white balance"
	        },
	        GainControl: {
	            0: "None",
	            1: "Low gain up",
	            2: "High gain up",
	            3: "Low gain down",
	            4: "High gain down"
	        },
	        Contrast: {
	            0: "Normal",
	            1: "Soft",
	            2: "Hard"
	        },
	        Saturation: {
	            0: "Normal",
	            1: "Low saturation",
	            2: "High saturation"
	        },
	        Sharpness: {
	            0: "Normal",
	            1: "Soft",
	            2: "Hard"
	        },
	        SubjectDistanceRange: {
	            0: "Unknown",
	            1: "Macro",
	            2: "Close view",
	            3: "Distant view"
	        },
	        FileSource: {
	            3: "DSC"
	        },
	
	        Components: {
	            0: "",
	            1: "Y",
	            2: "Cb",
	            3: "Cr",
	            4: "R",
	            5: "G",
	            6: "B"
	        }
	    };
	
	    function addEvent(element, event, handler) {
	        if (element.addEventListener) {
	            element.addEventListener(event, handler, false);
	        } else if (element.attachEvent) {
	            element.attachEvent("on" + event, handler);
	        }
	    }
	
	    function imageHasData(img) {
	        return !!img.exifdata;
	    }
	
	    function base64ToArrayBuffer(base64, contentType) {
	        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || '';
	        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
	        var binary = atob(base64);
	        var len = binary.length;
	        var buffer = new ArrayBuffer(len);
	        var view = new Uint8Array(buffer);
	        for (var i = 0; i < len; i++) {
	            view[i] = binary.charCodeAt(i);
	        }
	        return buffer;
	    }
	
	    function objectURLToBlob(url, callback) {
	        var http = new XMLHttpRequest();
	        http.open("GET", url, true);
	        http.responseType = "blob";
	        http.onload = function (e) {
	            if (this.status == 200 || this.status === 0) {
	                callback(this.response);
	            }
	        };
	        http.send();
	    }
	
	    function getImageData(img, callback) {
	        function handleBinaryFile(binFile) {
	            var data = findEXIFinJPEG(binFile);
	            var iptcdata = findIPTCinJPEG(binFile);
	            img.exifdata = data || {};
	            img.iptcdata = iptcdata || {};
	            if (callback) {
	                callback.call(img);
	            }
	        }
	
	        if (img.src) {
	            if (/^data\:/i.test(img.src)) {
	                var arrayBuffer = base64ToArrayBuffer(img.src);
	                handleBinaryFile(arrayBuffer);
	            } else if (/^blob\:/i.test(img.src)) {
	                var fileReader = new FileReader();
	                fileReader.onload = function (e) {
	                    handleBinaryFile(e.target.result);
	                };
	                objectURLToBlob(img.src, function (blob) {
	                    fileReader.readAsArrayBuffer(blob);
	                });
	            } else {
	                var http = new XMLHttpRequest();
	                http.onload = function () {
	                    if (this.status == 200 || this.status === 0) {
	                        handleBinaryFile(http.response);
	                    } else {
	                        throw "Could not load image";
	                    }
	                    http = null;
	                };
	                http.open("GET", img.src, true);
	                http.responseType = "arraybuffer";
	                http.send(null);
	            }
	        } else if (window.FileReader && (img instanceof window.Blob || img instanceof window.File)) {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	                if (debug) console.log("Got file of length " + e.target.result.byteLength);
	                handleBinaryFile(e.target.result);
	            };
	
	            fileReader.readAsArrayBuffer(img);
	        }
	    }
	
	    function findEXIFinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
	            if (debug) console.log("Not a valid JPEG");
	            return false;
	        }
	
	        var offset = 2,
	            length = file.byteLength,
	            marker;
	
	        while (offset < length) {
	            if (dataView.getUint8(offset) != 0xFF) {
	                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
	                return false;
	            }
	
	            marker = dataView.getUint8(offset + 1);
	            if (debug) console.log(marker);
	
	            if (marker == 225) {
	                if (debug) console.log("Found 0xFFE1 marker");
	
	                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);
	            } else {
	                offset += 2 + dataView.getUint16(offset + 2);
	            }
	        }
	    }
	
	    function findIPTCinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
	            if (debug) console.log("Not a valid JPEG");
	            return false;
	        }
	
	        var offset = 2,
	            length = file.byteLength;
	
	        var isFieldSegmentStart = function isFieldSegmentStart(dataView, offset) {
	            return dataView.getUint8(offset) === 0x38 && dataView.getUint8(offset + 1) === 0x42 && dataView.getUint8(offset + 2) === 0x49 && dataView.getUint8(offset + 3) === 0x4D && dataView.getUint8(offset + 4) === 0x04 && dataView.getUint8(offset + 5) === 0x04;
	        };
	
	        while (offset < length) {
	
	            if (isFieldSegmentStart(dataView, offset)) {
	                var nameHeaderLength = dataView.getUint8(offset + 7);
	                if (nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
	
	                if (nameHeaderLength === 0) {
	                    nameHeaderLength = 4;
	                }
	
	                var startOffset = offset + 8 + nameHeaderLength;
	                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
	
	                return readIPTCData(file, startOffset, sectionLength);
	
	                break;
	            }
	
	            offset++;
	        }
	    }
	    var IptcFieldMap = {
	        0x78: 'caption',
	        0x6E: 'credit',
	        0x19: 'keywords',
	        0x37: 'dateCreated',
	        0x50: 'byline',
	        0x55: 'bylineTitle',
	        0x7A: 'captionWriter',
	        0x69: 'headline',
	        0x74: 'copyright',
	        0x0F: 'category'
	    };
	    function readIPTCData(file, startOffset, sectionLength) {
	        var dataView = new DataView(file);
	        var data = {};
	        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
	        var segmentStartPos = startOffset;
	        while (segmentStartPos < startOffset + sectionLength) {
	            if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
	                segmentType = dataView.getUint8(segmentStartPos + 2);
	                if (segmentType in IptcFieldMap) {
	                    dataSize = dataView.getInt16(segmentStartPos + 3);
	                    segmentSize = dataSize + 5;
	                    fieldName = IptcFieldMap[segmentType];
	                    fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize);
	
	                    if (data.hasOwnProperty(fieldName)) {
	                        if (data[fieldName] instanceof Array) {
	                            data[fieldName].push(fieldValue);
	                        } else {
	                            data[fieldName] = [data[fieldName], fieldValue];
	                        }
	                    } else {
	                        data[fieldName] = fieldValue;
	                    }
	                }
	            }
	            segmentStartPos++;
	        }
	        return data;
	    }
	
	    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
	        var entries = file.getUint16(dirStart, !bigEnd),
	            tags = {},
	            entryOffset,
	            tag,
	            i;
	
	        for (i = 0; i < entries; i++) {
	            entryOffset = dirStart + i * 12 + 2;
	            tag = strings[file.getUint16(entryOffset, !bigEnd)];
	            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
	            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
	        }
	        return tags;
	    }
	
	    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
	        var type = file.getUint16(entryOffset + 2, !bigEnd),
	            numValues = file.getUint32(entryOffset + 4, !bigEnd),
	            valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart,
	            offset,
	            vals,
	            val,
	            n,
	            numerator,
	            denominator;
	
	        switch (type) {
	            case 1:
	            case 7:
	                if (numValues == 1) {
	                    return file.getUint8(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 4 ? valueOffset : entryOffset + 8;
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint8(offset + n);
	                    }
	                    return vals;
	                }
	
	            case 2:
	                offset = numValues > 4 ? valueOffset : entryOffset + 8;
	                return getStringFromDB(file, offset, numValues - 1);
	
	            case 3:
	                if (numValues == 1) {
	                    return file.getUint16(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 2 ? valueOffset : entryOffset + 8;
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 4:
	                if (numValues == 1) {
	                    return file.getUint32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 5:
	                if (numValues == 1) {
	                    numerator = file.getUint32(valueOffset, !bigEnd);
	                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
	                    val = new Number(numerator / denominator);
	                    val.numerator = numerator;
	                    val.denominator = denominator;
	                    return val;
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
	                        denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
	                        vals[n] = new Number(numerator / denominator);
	                        vals[n].numerator = numerator;
	                        vals[n].denominator = denominator;
	                    }
	                    return vals;
	                }
	
	            case 9:
	                if (numValues == 1) {
	                    return file.getInt32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 10:
	                if (numValues == 1) {
	                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	        }
	    }
	
	    function getStringFromDB(buffer, start, length) {
	        var outstr = "";
	        for (n = start; n < start + length; n++) {
	            outstr += String.fromCharCode(buffer.getUint8(n));
	        }
	        return outstr;
	    }
	
	    function readEXIFData(file, start) {
	        if (getStringFromDB(file, start, 4) != "Exif") {
	            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
	            return false;
	        }
	
	        var bigEnd,
	            tags,
	            tag,
	            exifData,
	            gpsData,
	            tiffOffset = start + 6;
	
	        if (file.getUint16(tiffOffset) == 0x4949) {
	            bigEnd = false;
	        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
	            bigEnd = true;
	        } else {
	            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
	            return false;
	        }
	
	        if (file.getUint16(tiffOffset + 2, !bigEnd) != 0x002A) {
	            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
	            return false;
	        }
	
	        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
	
	        if (firstIFDOffset < 0x00000008) {
	            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset + 4, !bigEnd));
	            return false;
	        }
	
	        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);
	
	        if (tags.ExifIFDPointer) {
	            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
	            for (tag in exifData) {
	                switch (tag) {
	                    case "LightSource":
	                    case "Flash":
	                    case "MeteringMode":
	                    case "ExposureProgram":
	                    case "SensingMethod":
	                    case "SceneCaptureType":
	                    case "SceneType":
	                    case "CustomRendered":
	                    case "WhiteBalance":
	                    case "GainControl":
	                    case "Contrast":
	                    case "Saturation":
	                    case "Sharpness":
	                    case "SubjectDistanceRange":
	                    case "FileSource":
	                        exifData[tag] = StringValues[tag][exifData[tag]];
	                        break;
	
	                    case "ExifVersion":
	                    case "FlashpixVersion":
	                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
	                        break;
	
	                    case "ComponentsConfiguration":
	                        exifData[tag] = StringValues.Components[exifData[tag][0]] + StringValues.Components[exifData[tag][1]] + StringValues.Components[exifData[tag][2]] + StringValues.Components[exifData[tag][3]];
	                        break;
	                }
	                tags[tag] = exifData[tag];
	            }
	        }
	
	        if (tags.GPSInfoIFDPointer) {
	            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
	            for (tag in gpsData) {
	                switch (tag) {
	                    case "GPSVersionID":
	                        gpsData[tag] = gpsData[tag][0] + "." + gpsData[tag][1] + "." + gpsData[tag][2] + "." + gpsData[tag][3];
	                        break;
	                }
	                tags[tag] = gpsData[tag];
	            }
	        }
	
	        return tags;
	    }
	
	    EXIF.getData = function (img, callback) {
	        if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) return false;
	
	        if (!imageHasData(img)) {
	            getImageData(img, callback);
	        } else {
	            if (callback) {
	                callback.call(img);
	            }
	        }
	        return true;
	    };
	
	    EXIF.getTag = function (img, tag) {
	        if (!imageHasData(img)) return;
	        return img.exifdata[tag];
	    };
	
	    EXIF.getAllTags = function (img) {
	        if (!imageHasData(img)) return {};
	        var a,
	            data = img.exifdata,
	            tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    };
	
	    EXIF.pretty = function (img) {
	        if (!imageHasData(img)) return "";
	        var a,
	            data = img.exifdata,
	            strPretty = "";
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                if ((0, _typeof3.default)(data[a]) == "object") {
	                    if (data[a] instanceof Number) {
	                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
	                    } else {
	                        strPretty += a + " : [" + data[a].length + " values]\r\n";
	                    }
	                } else {
	                    strPretty += a + " : " + data[a] + "\r\n";
	                }
	            }
	        }
	        return strPretty;
	    };
	
	    EXIF.readFromBinaryFile = function (file) {
	        return findEXIFinJPEG(file);
	    };
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return EXIF;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}).call(undefined);

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(38);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(128);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Home = __webpack_require__(53);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _SmallImages = __webpack_require__(121);
	
	var _SmallImages2 = _interopRequireDefault(_SmallImages);
	
	var _PlayAnimation = __webpack_require__(120);
	
	var _PlayAnimation2 = _interopRequireDefault(_PlayAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	exports.default = new _vueRouter2.default({
	  mode: 'history',
	  base: __dirname,
	  routes: [{ path: '/', component: _Home2.default }, { path: '/small-images', component: _SmallImages2.default }, { path: '/play-animation', component: _PlayAnimation2.default }, { path: '*', redirect: '/' }]
	});
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(38);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(11);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  beforeCropImage: null,
	  mainImage: null,
	  smallImages: [],
	  isAnimatingMode: false
	};
	
	var actions = {
	  setBeforeCropImage: function setBeforeCropImage(_ref, image) {
	    var commit = _ref.commit;
	    return commit('setBeforeCropImage', image);
	  },
	  setMainImage: function setMainImage(_ref2, image) {
	    var commit = _ref2.commit;
	    return commit('setMainImage', image);
	  },
	  addSmallImages: function addSmallImages(_ref3, image) {
	    var commit = _ref3.commit;
	    return commit('addSmallImages', image);
	  },
	  removeSmallImages: function removeSmallImages(_ref4, image) {
	    var commit = _ref4.commit;
	    return commit('removeSmallImages', image);
	  },
	  setAnimatingMode: function setAnimatingMode(_ref5, status) {
	    var commit = _ref5.commit;
	    return commit('setAnimatingMode', status);
	  }
	};
	
	var mutations = {
	  setBeforeCropImage: function setBeforeCropImage(state, image) {
	    state.beforeCropImage = image;
	  },
	  setMainImage: function setMainImage(state, image) {
	    state.mainImage = image;
	  },
	  addSmallImages: function addSmallImages(state, image) {
	    state.smallImages.push(image);
	  },
	  removeSmallImage: function removeSmallImage(state, image) {
	    var index = state.smallImages.indexOf(image);
	    state.smallImages.splice(index, 1);
	  },
	  setAnimatingMode: function setAnimatingMode(state, status) {
	    state.isAnimatingMode = status;
	  }
	};
	
	var getters = {
	  beforeCropImage: function beforeCropImage() {
	    return state.beforeCropImage;
	  },
	  mainImage: function mainImage() {
	    return state.mainImage;
	  },
	  smallImages: function smallImages() {
	    return state.smallImages;
	  },
	  displayImage: function displayImage(state) {
	    return state.mainImage || '';
	  },
	  isAnimatingMode: function isAnimatingMode() {
	    return state.isAnimatingMode;
	  }
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  actions: actions,
	  mutations: mutations,
	  getters: getters
	});

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Home = __webpack_require__(53);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Modal = __webpack_require__(119);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FooterComp = __webpack_require__(118);
	
	var _FooterComp2 = _interopRequireDefault(_FooterComp);
	
	var _vuex = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    'isAnimatingMode': 'isAnimatingMode'
	  })),
	  components: {
	    Home: _Home2.default,
	    FooterComp: _FooterComp2.default,
	    Modal: _Modal2.default
	  },
	  mounted: function mounted() {}
	};

/***/ },
/* 59 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'footer-comp',
	  mounted: function mounted() {
	    var ua = window.navigator.userAgent;
	    var regex = /(iPhone|iPad|iPod)/g;
	    if (regex.test(ua)) {
	      var footer = document.querySelector('footer.hero-foot');
	
	      footer.style.overflowY = 'scroll';
	      footer.style.WebkitOverflowScrolling = 'touch';
	    }
	  }
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'home',
	  data: function data() {
	    return {
	      cropper: {}
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    'mainImage': 'mainImage',
	    'displayImage': 'displayImage'
	  }), {
	    checkCropImage: function checkCropImage() {
	      if (!this.mainImage) return false;
	      return true;
	    },
	    uploadButtonMessage: function uploadButtonMessage() {
	      if (!this.mainImage) return 'Upload an Image';
	      return 'Reupload';
	    },
	    instructionMessage: function instructionMessage() {
	      if (!this.mainImage) return '<strong>Step 1.</strong> Upload Your Big Image';
	      return '';
	    }
	  }),
	  methods: {
	    uploadHandler: function uploadHandler(e) {
	      console.log('uploadHandler');
	      var files = e.target.files || e.dataTransfer.files;
	      if (!files.length) return;
	      this.createImage(files[0]);
	    },
	    createImage: function createImage(file) {
	      var _this = this;
	
	      console.log('createImage');
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        var img = e.target.result;
	        vm.$store.commit('setBeforeCropImage', img);
	        var image = {
	          mode: 'home',
	          src: img
	        };
	        _this.$events.fire('displayModal', image);
	      };
	      reader.readAsDataURL(file);
	    }
	  },
	  mounted: function mounted() {
	    this.$store.commit('setAnimatingMode', false);
	  }
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _exif = __webpack_require__(55);
	
	var _exif2 = _interopRequireDefault(_exif);
	
	var _croppie = __webpack_require__(54);
	
	var _croppie2 = _interopRequireDefault(_croppie);
	
	var _vuex = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.EXIF = _exif2.default;
	exports.default = {
	  name: 'modal',
	  data: function data() {
	    return {
	      cropper: {},
	      showModal: false,
	      mode: '',
	      imageSrc: ''
	    };
	  },
	
	  computed: {
	    cropElement: function cropElement() {
	      return document.querySelector('.cropper-area');
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    'setBeforeCropImage': 'setBeforeCropImage'
	  }), {
	    init: function init() {
	      var indVar = window.screen.width > window.screen.height ? window.screen.height : window.screen.width;
	      var factor = window.screen.width > window.screen.height ? 0.4 : 0.6666;
	      var displayImageWidth = Math.round(indVar * factor);
	
	      this.cropper = new _croppie2.default(this.cropElement, {
	        enableExif: true,
	        viewport: {
	          width: displayImageWidth - 20,
	          height: displayImageWidth - 20,
	          type: 'square'
	        },
	        boundary: {
	          width: displayImageWidth,
	          height: displayImageWidth
	        }
	      });
	    },
	    initEvents: function initEvents() {
	      this.$events.listen('displayModal', this.displayModal);
	    },
	    displayModal: function displayModal(image) {
	      this.mode = image.mode;
	      this.showModal = true;
	      var that = this;
	      if (this.imageSrc !== image.src) {
	        this.imageSrc = image.src;
	        setTimeout(function () {
	          that.cropper.bind({
	            url: image.src,
	            zoom: 0
	          }).then(function () {
	            console.log('bind complete');
	          });
	        }, 100);
	      }
	    },
	    showResult: function showResult() {
	      var that = this;
	      var size = 0;
	      if (this.mode === 'home') {
	        size = 1200;
	      } else if (this.mode === 'small-images') {
	        size = 256;
	      }
	      this.cropper.result({
	        type: 'base64',
	        size: { width: size, height: size },
	        format: 'jpeg'
	      }).then(function (response) {
	        setTimeout(function () {
	          that.showModal = false;
	          var canvas = response;
	          var dataURL = canvas;
	          if (that.mode === 'home') {
	            that.$store.commit('setMainImage', dataURL);
	          } else if (that.mode === 'small-images') {
	            that.$store.commit('addSmallImages', dataURL);
	          }
	          that.cropper.bind({ url: '', zoom: 0 });
	        }, 100);
	      });
	    }
	  }),
	  mounted: function mounted() {
	    this.init();
	    this.initEvents();
	  }
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(64);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(11);
	
	var _velocityAnimate = __webpack_require__(115);
	
	var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var w = window;
	var d = document;
	var e = d.documentElement;
	var g = d.getElementsByTagName('body')[0];
	
	var mainImage;
	var smallImages = [];
	var pWrapper;
	var finalImage;
	
	var canvas;
	var ctx;
	var hCanvas;
	var hCtx;
	
	var sx = 0;
	var sy = 0;
	var sWidth = 0;
	var sHeight = 0;
	var dx = 0;
	var dy = 0;
	var dWidth = 0;
	var dHeight = 0;
	
	var period = 8000;
	
	function getRandomInt(min, max) {
	  return Math.floor(Math.random() * (max - min + 1)) + min;
	}
	
	exports.default = {
	  name: 'play-animation',
	  data: function data() {
	    return {
	      isAnimating: true,
	      showFinal: false,
	      showButtons: false,
	      finalDataImage: ''
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    'mainImage': 'mainImage',
	    'smallImages': 'smallImages'
	  }), {
	    screenWidth: function screenWidth() {
	      return w.innerWidth || e.clientWidth || g.clientWidth;
	    },
	    screenHeight: function screenHeight() {
	      return w.innerHeight || e.clientHeight || g.clientHeight;
	    },
	    detectedSize: function detectedSize() {
	      var minSize = Math.min(this.screenWidth, this.screenHeight);
	      var result = minSize - minSize % this.grid;
	      return result;
	    },
	    grid: function grid() {
	      if (this.screenWidth <= 480) {
	        return 24;
	      } else if (this.screenWidth <= 800) {
	        return 36;
	      }
	      return 48;
	    },
	    gridColumn: function gridColumn() {
	      return this.detectedSize / this.grid;
	    },
	    getFinalImage: function getFinalImage() {
	      return this.finalDataImage;
	    },
	    isMobile: function isMobile() {
	      var ua = window.navigator.userAgent;
	      return (/mobile/ig.test(ua)
	      );
	    }
	  }),
	  methods: {
	    init: function init() {
	      this.isAnimating = true;
	      this.showFinal = false;
	      this.showButtons = false;
	
	
	      canvas = document.getElementById('canvas');
	      ctx = canvas.getContext('2d');
	      hCanvas = document.getElementById('helper');
	      hCtx = hCanvas.getContext('2d');
	
	      pWrapper = document.getElementById('particle_wrapper');
	      finalImage = document.getElementById('final_image');
	
	      var that = this;
	
	      this.loadSmallImages(this.smallImages, function (images) {
	        smallImages = images;
	        mainImage = new Image();
	        mainImage.src = that.mainImage;
	        mainImage.onload = that.drawImage;
	      });
	    },
	    loadSmallImages: function loadSmallImages(sources, callback) {
	      var images = [];
	      var loadedImages = 0;
	      var numImages = sources.length;
	
	      for (var i = 0; i < numImages; i++) {
	        images[i] = new Image();
	        images[i].onload = function () {
	          if (++loadedImages >= numImages) {
	            callback(images);
	          }
	        };
	        images[i].src = sources[i];
	      }
	    },
	    drawImage: function drawImage() {
	      sWidth = mainImage.width;
	      sHeight = mainImage.height;
	      dWidth = this.detectedSize;
	      dHeight = dWidth;
	
	      console.log('sWidth => [' + sWidth + '] | sHeight => [' + sHeight + ']');
	
	      canvas.width = dWidth;
	      canvas.height = dHeight;
	
	      ctx.clearRect(0, 0, canvas.width, canvas.height);
	      ctx.drawImage(mainImage, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
	
	      ctx.globalAlpha = 0.3333;
	
	      for (var i = 0; i < this.gridColumn; i++) {
	        for (var j = 0; j < this.gridColumn; j++) {
	          var rand = getRandomInt(0, smallImages.length - 1);
	          ctx.drawImage(smallImages[rand], this.grid * j, this.grid * i, this.grid, this.grid);
	        }
	      }
	
	      this.finalDataImage = canvas.toDataURL('image/jpg');
	
	      this.setupParticleWrapper();
	    },
	    setupParticleWrapper: function setupParticleWrapper() {
	      this.isAnimating = true;
	      this.showFinal = false;
	      this.showButtons = false;
	
	      finalImage.removeAttribute('style');
	
	      while (pWrapper.hasChildNodes()) {
	        pWrapper.removeChild(pWrapper.lastChild);
	      }
	      pWrapper.removeAttribute('style');
	
	      pWrapper.style.width = canvas.width + 'px';
	      pWrapper.style.height = canvas.height + 'px';
	
	      this.generateParticles();
	    },
	    generateParticles: function generateParticles() {
	      var total = this.gridColumn * this.gridColumn;
	      var i = 0;
	      var j = 0;
	
	      for (var n = 0; n < total; n++) {
	        if (j >= this.gridColumn) {
	          j = 0;i++;
	        }
	        var iData = ctx.getImageData(this.grid * j, this.grid * i, this.grid, this.grid);
	        hCanvas.width = hCanvas.height = this.grid;
	        hCtx.putImageData(iData, 0, 0);
	        var randomHeight = getRandomInt(200, 400);
	        var img = new Image();
	        img.src = hCanvas.toDataURL('image/jpg');
	        img.width = img.height = this.grid;
	        img.style.transform = 'translateZ(' + randomHeight + 'px)';
	
	        pWrapper.appendChild(img);
	
	        j++;
	      }
	
	      var rand = getRandomInt(1, total);
	      var count = 0;
	      var particles = pWrapper.querySelectorAll('img');
	
	      var that = this;
	
	      setTimeout(function () {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(particles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var particle = _step.value;
	
	            var seconds = count++ === rand ? period + 1000 : getRandomInt(1000, period);
	            particle.style.transitionDuration = seconds + 'ms';
	            particle.style.transitionTimingFunction = 'ease-out';
	            particle.style.transform = 'translateZ(0px)';
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }, 1000);
	
	      setTimeout(function () {
	        that.isAnimating = false;
	        that.showFinal = true;
	        if (finalImage.src !== that.getFinalImage) {
	          finalImage.src = that.getFinalImage;
	          finalImage.onload = endingAnimate;
	        } else {
	          endingAnimate();
	        }
	        function endingAnimate() {
	          if (that.screenWidth > that.screenHeight) {
	            (0, _velocityAnimate2.default)(finalImage, {
	              width: '*=0.8',
	              height: '*=0.8',
	              top: '-=10%'
	            }, { duration: '300ms' });
	          } else {
	            var offsetLeft = Math.round(canvas.width / 2);
	            var offsetTop = Math.round(canvas.height / 2);
	            finalImage.style.marginTop = -offsetTop + 'px';
	            finalImage.style.marginLeft = -offsetLeft + 'px';
	
	            (0, _velocityAnimate2.default)(finalImage, { top: '-=10%' }, { duration: '300ms' });
	          }
	          setTimeout(function () {
	            that.showButtons = true;
	            var downloadBtn = document.getElementById('download_button');
	            downloadBtn.href = canvas.toDataURL('image/jpeg');
	          }, 200);
	        }
	      }, period + 3000);
	    }
	  },
	  mounted: function mounted() {
	    this.$store.commit('setAnimatingMode', true);
	    if (this.mainImage) {
	      this.init();
	    } else {}
	  }
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'small-images',
	  data: function data() {
	    return {
	      maximumImage: 16
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    'smallImages': 'smallImages'
	  }), {
	    uploadButtonMessage: function uploadButtonMessage() {
	      if (!this.smallImages.length) return 'Upload an Image';
	      return 'Add More Image';
	    },
	    instructionMessage: function instructionMessage() {
	      if (!this.smallImages.length) return '<strong>Step 2.</strong> Add Your Small Images (up to 16 images)';
	      return this.smallImages.length + ' of ' + this.maximumImage + '<br>Click Any Image to Remove';
	    }
	  }),
	  methods: {
	    uploadHandler: function uploadHandler(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      if (!files.length) return;
	      this.createImage(files[0]);
	    },
	    createImage: function createImage(file) {
	      var _this = this;
	
	      var reader = new FileReader();
	      var vm = this;
	      reader.onload = function (e) {
	        var img = e.target.result;
	        vm.$store.commit('setBeforeCropImage', img);
	        var image = {
	          mode: 'small-images',
	          src: img
	        };
	        _this.$events.fire('displayModal', image);
	      };
	      reader.readAsDataURL(file);
	    },
	    confirmRemoveImage: function confirmRemoveImage(image) {
	      if (window.confirm('Do you really want to remove this image?')) {
	        this.$store.commit('removeSmallImage', image);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.$store.commit('setAnimatingMode', false);
	  }
	};

/***/ },
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 110 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 111 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 112 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 113 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 114 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 115 */,
/* 116 */,
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(110)
	
	/* script */
	__vue_exports__ = __webpack_require__(58)
	
	/* template */
	var __vue_template__ = __webpack_require__(123)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(111)
	
	/* script */
	__vue_exports__ = __webpack_require__(59)
	
	/* template */
	var __vue_template__ = __webpack_require__(124)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(113)
	
	/* script */
	__vue_exports__ = __webpack_require__(61)
	
	/* template */
	var __vue_template__ = __webpack_require__(126)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(109)
	
	/* script */
	__vue_exports__ = __webpack_require__(62)
	
	/* template */
	var __vue_template__ = __webpack_require__(122)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(112)
	
	/* script */
	__vue_exports__ = __webpack_require__(63)
	
	/* template */
	var __vue_template__ = __webpack_require__(125)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "animated-area"
	  }, [(!mainImage) ? _h('section', {
	    staticClass: "hero is-fullheight main-background"
	  }, [_h('div', {
	    staticClass: "hero-body"
	  }, [_h('div', {
	    staticClass: "container"
	  }, [_h('center', [_m(0), " ", _h('router-link', {
	    staticClass: "button is-danger is-medium",
	    attrs: {
	      "to": "/"
	    }
	  }, ["Back"])])])])]) : _e(), " ", _m(1), " ", _m(2), " ", _h('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (isAnimating),
	      expression: "isAnimating"
	    }],
	    attrs: {
	      "id": "particle_wrapper"
	    }
	  }), " ", _h('img', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (showFinal),
	      expression: "showFinal"
	    }],
	    attrs: {
	      "id": "final_image"
	    }
	  }), " ", _h('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (showButtons),
	      expression: "showButtons"
	    }],
	    staticClass: "button-wrapper"
	  }, [(isMobile) ? _h('center', [_m(3)]) : _e(), " ", _h('center', [_h('a', {
	    staticClass: "button is-light is-medium",
	    on: {
	      "click": setupParticleWrapper
	    }
	  }, ["Replay"]), " ", (!isMobile) ? _h('a', {
	    staticClass: "button is-success is-medium",
	    attrs: {
	      "download": "mosaic.png",
	      "id": "download_button"
	    }
	  }, ["Download"]) : _e(), " ", _h('router-link', {
	    staticClass: "button is-danger is-medium",
	    attrs: {
	      "to": "/"
	    }
	  }, ["Restart"])])])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('p', {
	    staticClass: "instruction warning-message"
	  }, ["Main image has not been selected!"])
	}},function (){with(this) {
	  return _h('canvas', {
	    attrs: {
	      "id": "canvas"
	    }
	  })
	}},function (){with(this) {
	  return _h('canvas', {
	    attrs: {
	      "id": "helper"
	    }
	  })
	}},function (){with(this) {
	  return _h('p', {
	    staticClass: "instruction"
	  }, ["Touch and hold to save image"])
	}}]}

/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('section', {
	    staticClass: "hero is-fullheight main-background"
	  }, [_h('router-view'), " ", _h('footer-comp', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!isAnimatingMode),
	      expression: "!isAnimatingMode"
	    }]
	  }), " ", _h('modal')])
	}},staticRenderFns: []}

/***/ },
/* 124 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _m(0)
	}},staticRenderFns: [function (){with(this) {
	  return _h('footer', {
	    staticClass: "hero-foot"
	  }, [_h('div', {
	    staticClass: "container has-text-centered"
	  }, [_h('p', {
	    staticClass: "express-condolence"
	  }, ["\n      In Remembrance of His Majesty", _h('br'), " ", _h('span', {
	    staticClass: "big-font"
	  }, ["King Bhumibol Adulyadej"])]), " ", _h('div', {
	    staticClass: "share-container"
	  }, [_h('div', {
	    staticClass: "fb-share-button share-button",
	    attrs: {
	      "data-href": "https://grief2grace.firebaseapp.com",
	      "data-layout": "button_count",
	      "data-size": "small",
	      "data-mobile-iframe": "false"
	    }
	  }, [_h('a', {
	    staticClass: "fb-xfbml-parse-ignore",
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fgrief2grace.firebaseapp.com%2F&src=sdkpreparse"
	    }
	  }, ["Share"])]), " ", _h('a', {
	    staticClass: "twitter-share-button",
	    attrs: {
	      "href": "https://grief2grace.firebaseapp.com"
	    }
	  }, ["\n      Tweet"]), " ", _h('div', {
	    staticClass: "line-it-button share-button",
	    attrs: {
	      "style": "display: none;",
	      "data-type": "share-a",
	      "data-lang": "en"
	    }
	  })])])])
	}}]}

/***/ },
/* 125 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "hero-body main-background"
	  }, [_h('div', {
	    staticClass: "container has-text-centered"
	  }, [_h('div', {
	    staticClass: "columns is-mobile"
	  }, [_m(0), " ", _h('div', {
	    staticClass: "column is-11-mobile is-two-thirds-tablet is-half-desktop"
	  }, [_h('div', {
	    staticClass: "collection-container"
	  }, [_l((smallImages), function(image) {
	    return _h('a', {
	      staticClass: "image-container",
	      on: {
	        "click": function($event) {
	          confirmRemoveImage(image)
	        }
	      }
	    }, [_h('img', {
	      staticClass: "image-display",
	      attrs: {
	        "src": image,
	        "alt": ""
	      }
	    })])
	  })])]), " ", _m(1)]), " ", _h('p', {
	    staticClass: "instruction",
	    domProps: {
	      "innerHTML": _s(instructionMessage)
	    }
	  }), " ", _h('router-link', {
	    staticClass: "button is-warning is-medium",
	    attrs: {
	      "to": "/"
	    }
	  }, ["Back"]), " ", (smallImages.length < maximumImage) ? _h('a', {
	    staticClass: "button is-light is-medium file-upload"
	  }, [_h('span', [_s(uploadButtonMessage)]), " ", _h('input', {
	    attrs: {
	      "type": "file",
	      "id": "file_picker",
	      "accept": "image/*"
	    },
	    on: {
	      "change": uploadHandler
	    }
	  })]) : _e(), " ", (smallImages.length) ? _h('router-link', {
	    staticClass: "button is-primary is-medium",
	    attrs: {
	      "to": "/play-animation"
	    }
	  }, ["Create Mosaic"]) : _e()])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "column"
	  })
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "column"
	  })
	}}]}

/***/ },
/* 126 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "modal",
	    class: {
	      'is-active': showModal
	    },
	    attrs: {
	      "id": "myModal"
	    }
	  }, [_m(0), " ", _h('div', {
	    staticClass: "modal-card"
	  }, [_h('header', {
	    staticClass: "modal-card-head"
	  }, [_m(1), " ", _h('button', {
	    staticClass: "delete",
	    on: {
	      "click": function($event) {
	        showModal = false
	      }
	    }
	  })]), " ", _m(2), " ", _h('footer', {
	    staticClass: "modal-card-foot"
	  }, [_h('center', [_h('a', {
	    staticClass: "button is-primary",
	    on: {
	      "click": showResult
	    }
	  }, ["Save changes"]), " ", _h('a', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        showModal = false
	      }
	    }
	  }, ["Cancel"])])])])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "modal-background"
	  })
	}},function (){with(this) {
	  return _h('p', {
	    staticClass: "modal-card-title"
	  }, ["Crop your image"])
	}},function (){with(this) {
	  return _h('section', {
	    staticClass: "modal-card-body has-text-centered"
	  }, [_h('div', {
	    staticClass: "container"
	  }, [_h('div', {
	    staticClass: "cropper-area"
	  })])])
	}}]}

/***/ },
/* 127 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "hero-body main-background"
	  }, [_h('div', {
	    staticClass: "container has-text-centered"
	  }, [_h('div', {
	    staticClass: "columns is-mobile"
	  }, [_m(0), " ", _h('div', {
	    staticClass: "column is-two-thirds-mobile is-half-tablet is-one-quarter-desktop"
	  }, [_h('figure', {
	    staticClass: "image",
	    attrs: {
	      "id": "main_image"
	    }
	  }, [(displayImage) ? _h('img', {
	    attrs: {
	      "src": displayImage
	    }
	  }) : _h('img', {
	    attrs: {
	      "src": "/static/img/9.svg"
	    }
	  }), " "])]), " ", _m(1)]), " ", _h('p', {
	    staticClass: "instruction",
	    domProps: {
	      "innerHTML": _s(instructionMessage)
	    }
	  }), " ", _h('a', {
	    staticClass: "button is-light is-medium file-upload"
	  }, [_h('span', [_s(uploadButtonMessage)]), " ", _h('input', {
	    attrs: {
	      "type": "file",
	      "id": "file_picker",
	      "accept": "image/*"
	    },
	    on: {
	      "change": uploadHandler
	    }
	  })]), " ", (mainImage) ? _h('router-link', {
	    staticClass: "button is-primary is-medium",
	    attrs: {
	      "to": "/small-images"
	    }
	  }, ["Go to Step 2"]) : _e()])])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "column"
	  })
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "column"
	  })
	}}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.f508424aeb5062295f54.js